export const axeptioUrls = {
  STATIC_URL: 'https://static.axept.io/',
  CLIENT_URL: 'https://client.axept.io/',
  API_URL: 'https://api.axept.io/',
  IMAGE_URL: 'https://axeptio.imgix.net',
  FAVICONS_URL: 'https://favicons.axept.io/',
};
